import script from "./BannerCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerCategory.vue?vue&type=script&setup=true&lang=js"

import "./BannerCategory.vue?vue&type=style&index=0&id=317e6374&scoped=true&lang=css"
import "./BannerCategory.vue?vue&type=style&index=1&id=317e6374&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-317e6374"]])

export default __exports__